import { Component, Inject, OnDestroy } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService, } from '@azure/msal-angular';


import { RouterOutlet } from '@angular/router';

import { filter, Subject, takeUntil } from 'rxjs';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';

import "@shui/core/sh-access-bar";
import "@shui/core/sh-box";
import "@shui/core/sh-divider";
import "@shui/core/sh-empty-state";
import "@shui/core/sh-grid";
import "@shui/core/sh-list";
import "@shui/core/sh-modal";
import "@shui/core/sh-page";
import "@shui/core/sh-pane";
import "@shui/core/sh-popover";
import "@shui/core/sh-search";
import "@shui/core/sh-spinner";
import "@shui/core/sh-card";
import "@shui/core/sh-button";
import "@shui/core/sh-checkbox";
import "@shui/core/sh-text";
import "@shui/core/sh-user-identifier";
import "@shui/core/sh-icon";
import "@shui/core/sh-wrapper";
import "@shui/core/sh-splash-screen";
import "@shui/core/sh-menu-item";
import "@shui/core/sh-notifications";
import "@shui/core/sh-tag";
import "@shui/core/sh-dropdown";
import "@shui/core/sh-table";
import "@shui/core/sh-pagination";
import "@shui/core/sh-tabs";
import "@shui/core/sh-input-text";
import "@shui/core/sh-split-button";
import "@shui/core/sh-tool";
import "@shui/core/sh-tooltip";
import "@shui/core/sh-toggle";
import "@shui/core/sh-radio-button";
import "@shui/core/sh-switch";
import "@shui/core/sh-stepper";
import { Chart } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import { DataService } from 'src/core/services/data.service';
import { AppConfigService } from 'src/core/services/appconfig.service';
import { LanguageService } from 'src/core/services/language.service';
Chart.register(annotationPlugin);
Chart.register(zoomPlugin);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [
    RouterOutlet
  ]
})

export class AppComponent implements OnDestroy {
  title = 'LS Service Copilot';
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  activeUser: string | undefined = "unknown user";
  isAuthenticated = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private dataService: DataService,
    private appconfigService: AppConfigService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {

    //Listening to Configuration & Feature Flags
    this.appconfigService.connect();

    // Bridge language feature flags
    this.appconfigService.featureFlags$
      .pipe(takeUntil(this._destroying$))
      .subscribe(flags => {
        this.languageService.updateFeatureFlags({
          langZh: flags.langZh,
          langJa: flags.langJa,
          langPt: flags.langPt,
          langEs: flags.langEs,
        });
      });
    
    this.authService.handleRedirectObservable()
      .pipe(takeUntil(this._destroying$))
      .subscribe({
        next: (result: AuthenticationResult | null) => {
          if (result?.account) {
            this.authService.instance.setActiveAccount(result.account);
          }
        },
        error: (error) => {
          console.error('MSAL redirect handling failed', error);
        }
      });

    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/login';
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
